module.exports = __webpack_public_path__ + "static/media/Miasta.91e884bd.svg";